import { useQuery } from '@tanstack/react-query';
import { apiFetch } from './adalConfig';
import { Client } from './globalTypes/objects';
import React from 'react';

export const ClientsContext = React.createContext<Client[]>([]);

const fetchClients = async () => (await apiFetch<Client[]>('/Api/Clients/GetAll?includeInactive=true')).data;

function ClientsProvider({ children }) {
  const { data } = useQuery({
    queryKey: ['clients'],
    queryFn: fetchClients,
  });

  return data ? <ClientsContext.Provider value={data}>{children}</ClientsContext.Provider> : null;
}
const ClientsConsumer = ClientsContext.Consumer;

export { ClientsProvider, ClientsConsumer };
